/**
 * 门诊详情 请求 api
 */
// 引入工具函数
import req from '@/utils/request';


// 获取门诊全部信息
export const getOutpatientAllDetailApi = (params) => {
        return req.get('/order/info/door', params);
    }
    //查询病历
export const caseDiagnosisDetailApi = (params) => {
        return req.post('/caseDiagnosis/detail', params);
    }
    //编辑病历
export const editCaseDiagnosisApi = (params) => {
        return req.post('/caseDiagnosis/save', params);
    }
    //编辑处方
export const editPrescriptionApi = (params) => {
        return req.post('/caseProjectRecipe/projectSave', params);
    }
    //删除处方
export const removePrescriptionApi = (params) => {
        return req.post('/caseProjectRecipe/projectDelete', params);
    }
    //产看库存
export const getInventoryApi = (params) => {
    return req.post('/hosp/drug/getDrugs', params);
}

// 搜索非处方项目
export const getOtherProjectApi = (params) => {
        return req.post('/hosp/goods/search', params);
    }
    // 完成接诊
export const saveOrderApi = (params) => {
    return req.post('/order/info/saveOrderCase', params);
}

//查询处方信息
export const getOutpatientDetailApi = (params) => {
    return req.get('/caseProjectRecipe/caseProjects', params);
}

//复制所有历史就诊信息
export const copyAllHistoryApi = (params) => {
    return req.post('/order/info/copyOrderCase', params);
}

//复制所有历史就诊信息
export const deleteAllDiaApi = (params) => {
    return req.post('/order/info/draftDelete', params);
}

// 复制门诊单（用于收费中就诊历史门诊单的复制）
export const copyOutpatientOrderApi = (params) => {
    return req.post('/order/info/copyAndFinishOrderInfo', params);
}

//获取病例信息
export const caseDiagnosisApi = (params) => {
    return req.get('/caseDiagnosis/detail', params);
}

//获取门诊看板统计信息
export const getPanel = (params) => {
        return req.post('/door/panel', params);
    }
    //获取门诊看板分页查询信息
export const getDoorPage = (params) => {
    return req.post('/door/doorPage', params);
}

//获取挂号看板数量
export const getPanelCount = (params) => {
        return req.post('/reg/panelCount', params);
    }
    //获取挂号看板list
export const getRegisterPanelList = (params) => {
        return req.post('/reg/panelList', params);
    }
    //获取挂号看板list统计
export const getPanelListCensus = (params) => {
        return req.post('/reg/panelListCensus', params);
    }
// 获取业绩明细统计-销售额
export const achievement = (params) => {
  return req.post('/saleReport/getSalesPerformanceTotal', params);
}
    //保存整个处方
export const saveDoorApi = (params) => {
    return req.post('/order/info/saveDoor', params);
}
//查询历史门诊信息
export const historyDoor = (params) => {
    return req.get('/order/info/history/door', params);
}

// 获取医生处方常用值
export const getOftenUsage = (params) => {
    return req.get('/caseProjectRecipe/recipeMethodHabit', params);
}

// 获取常用煎法
export const getOftenDecoction = (params) => {
    return req.post('/caseProjectRecipe/handling', params);
}

// 保存常用煎法
export const saveOftenDecoction = (params) => {
    return req.post('/caseProjectRecipe/handling/save', params);
}
